import React, { Component } from "react";
import { NavLink } from "react-router-dom";
import nav from "./Navigation.module.css";

class Navigation extends Component {
  state = {
    showMenu: "d-block mt-3",
    hiddenMenu: "d-none",
  };

  openMenu = () => {
    this.setState({
      showMenu: "d-none",
      hiddenMenu: "d-block rounded",
    });
  };

  closeMenu = () => {
    this.setState({
      showMenu: "d-block mt-3",
      hiddenMenu: "d-none",
    });
  };

  render() {
    return (
      <div>
        <nav className={nav.navbar}>
          <div className="container pt-3 py-lg-3">
            <div className="row">
              <div className="col-12 text-center pt-2 pb-1">
                <h1>
                  <NavLink className={nav.logo} exact to="/">
                    ফয়সাল
                  </NavLink>
                </h1>
              </div>
              <div className="col-12 text-center py-2 d-lg-none">
                <div className={this.state.showMenu}>
                  <i
                    style={{
                      background: "#00cf5d",
                      padding: "8px 10px",
                      color: "#ffffff",
                    }}
                    onClick={this.openMenu}
                    className="fa fa-bars"
                  ></i>
                </div>
              </div>
              <div className="col-12 text-center py-2 d-lg-none">
                <div
                  style={{ background: "#1d293a" }}
                  className={this.state.hiddenMenu}
                >
                  <i
                    style={{ padding: "8px 10px", color: "#ffffff" }}
                    onClick={this.closeMenu}
                    className="fa fa-times bg-danger"
                  ></i>
                  <div className={nav.expand}>
                    <NavLink
                      activeClassName={nav.activenav}
                      className={nav.navlink}
                      exact
                      to="/"
                    >
                      হোম
                    </NavLink>
                    <NavLink
                      activeClassName={nav.activenav}
                      className={nav.navlink}
                      exact
                      to="/about"
                    >
                      আমার সম্পর্কে
                    </NavLink>
                    <NavLink
                      activeClassName={nav.activenav}
                      className={nav.navlink}
                      exact
                      to="/skill"
                    >
                      দক্ষতা
                    </NavLink>
                    <NavLink
                      activeClassName={nav.activenav}
                      className={nav.navlink}
                      exact
                      to="/portfolio"
                    >
                      কাজসমুহ
                    </NavLink>
                    <NavLink
                      activeClassName={nav.activenav}
                      className={nav.navlink}
                      exact
                      to="/contact"
                    >
                      যোগাযোগ
                    </NavLink>
                    <NavLink
                      activeClassName={nav.activenav}
                      className={nav.navlink}
                      exact
                      to="/blog"
                    >
                      ব্লগ পড়ুন
                    </NavLink>
                  </div>
                </div>
              </div>
              <div className="col-12 text-center py-2 d-none d-lg-block">
                <NavLink
                  activeClassName={nav.activenav}
                  className={nav.navlink}
                  exact
                  to="/"
                >
                  হোম
                </NavLink>
                <NavLink
                  activeClassName={nav.activenav}
                  className={nav.navlink}
                  exact
                  to="/about"
                >
                  আমার সম্পর্কে
                </NavLink>
                <NavLink
                  activeClassName={nav.activenav}
                  className={nav.navlink}
                  exact
                  to="/skill"
                >
                  দক্ষতা
                </NavLink>
                <NavLink
                  activeClassName={nav.activenav}
                  className={nav.navlink}
                  exact
                  to="/portfolio"
                >
                  কাজসমুহ
                </NavLink>
                <NavLink
                  activeClassName={nav.activenav}
                  className={nav.navlink}
                  exact
                  to="/contact"
                >
                  যোগাযোগ
                </NavLink>
                <NavLink
                  activeClassName={nav.activenav}
                  className={nav.navlink}
                  exact
                  to="/blog"
                >
                  ব্লগ পড়ুন
                </NavLink>
              </div>
            </div>
          </div>
        </nav>
      </div>
    );
  }
}

export default Navigation;
